module.exports = __webpack_public_path__ + "img/home_menu_4_default.343f5d26.png";